import React from 'react';

const Qualifications = () => {
    return <div>Calificaciones</div>;
};

export default Qualifications;
